enum EDDRadioButtonValue {
  FIXED_TIME = '1',
  LEAD_TIME_AFTER_ESD = '2',
}

export default EDDRadioButtonValue
